"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.IntermediateRecordConfigSchema = exports.nodeType = exports.UIConfigSchema = void 0;
const zod_1 = require("zod");
exports.UIConfigSchema = zod_1.z.object({
    artifactSlug: zod_1.z.string().describe('Artifact slug'),
    description: zod_1.z.string().describe('Description'),
});
exports.nodeType = 'file_generatedReceivableResponseTape';
exports.IntermediateRecordConfigSchema = zod_1.z.object({
    operationDescription: zod_1.z
        .string()
        .describe('this will show up in operation node.'),
    tapeDescription: zod_1.z.string().describe('this will show up in tape node.'),
    useReceivableWaivers: zod_1.z.boolean().optional(),
});
exports.artifactType = 'receivableResponseTape';
//# sourceMappingURL=types.js.map